import {
  Box,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useMemo, useState } from "react";
import { showWarningSwal } from "../../functions/alert";
import { tagIjhsParticipants } from "../../functions/postData";
import NunitoText from "../general/NunitoText";
import ReusableButton from "../general/ReusableButton";

const GENERATE = "__generate__";
const radioStyle = { color: "#5E75C3" };
const radioGroupStyle = {
  alignItems: "flex-start",
  margin: "16px 40px 0",
  textAlign: "left",
};

const distinctIdentifiers = (rows) => {
  const seen = new Set();
  const choices = [];
  rows.forEach((row) => {
    const value = row.identifier;
    if (!value || seen.has(value)) return;
    seen.add(value);
    choices.push({
      value,
      competition:
        row.competition_name ||
        row.competition?.alias ||
        row.competition?.name ||
        "",
    });
  });
  return choices;
};

const defaultChoice = (choices) => {
  if (choices.length === 1) return choices[0].value;
  return GENERATE;
};

const buildPayload = (indices, choice) => {
  const payload = { participant_indices: indices };
  if (choice === GENERATE) {
    payload.generate_new = true;
  } else {
    payload.target_identifier = choice;
  }
  return payload;
};

export default function TagSameStudentModal({
  rows,
  onClose,
  onSuccess,
  setLoading,
}) {
  const choices = useMemo(() => distinctIdentifiers(rows), [rows]);
  const [choice, setChoice] = useState(() => defaultChoice(choices));

  const onConfirm = () => {
    if (rows.length < 2) {
      return showWarningSwal("Select at least two participants to tag.");
    }
    const indices = rows.map(
      (row) => row.participant_index || row.index_no
    );
    setLoading?.(true);
    tagIjhsParticipants(buildPayload(indices, choice))
      .then((data) => onSuccess(data))
      .catch((e) => console.log(e))
      .finally(() => setLoading?.(false));
  };

  return (
    <Box className="popUpModal" style={{ width: 640, minHeight: 320 }}>
      <NunitoText
        value="Tag as same student"
        fontSize={28}
        fontWeight={600}
        color="#5E75C3"
        marginTop={28}
      />
      <NunitoText
        value="Selected records will share one identifier."
        fontSize={18}
        fontWeight={500}
        marginTop={8}
      />
      <RadioGroup
        style={radioGroupStyle}
        value={choice}
        onChange={(e) => setChoice(e.target.value)}
      >
        <FormControlLabel
          value={GENERATE}
          control={<Radio style={radioStyle} />}
          label="Generate new identifier"
        />
        {choices.map((item) => (
          <FormControlLabel
            key={item.value}
            value={item.value}
            control={<Radio style={radioStyle} />}
            label={
              item.competition
                ? `Use existing: ${item.value}  (from ${item.competition})`
                : `Use existing: ${item.value}`
            }
          />
        ))}
      </RadioGroup>
      <Grid
        container
        justifyContent="space-evenly"
        style={{ marginBlock: "28px 20px" }}
      >
        <ReusableButton
          text="Cancel"
          bgColor="#8D8D8D"
          fontSize={22}
          height={56}
          width={220}
          onClick={onClose}
        />
        <ReusableButton
          text="Confirm tag"
          bgColor="#5E75C3"
          fontSize={22}
          height={56}
          width={220}
          onClick={onConfirm}
        />
      </Grid>
    </Box>
  );
}
